import { render, staticRenderFns } from "./BaseScrollActive.vue?vue&type=template&id=1ac1cf63&"
import script from "./BaseScrollActive.vue?vue&type=script&lang=js&"
export * from "./BaseScrollActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_e0fc12eb4d0f55f4cb07c19882e21395/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports